import { createSelector } from 'reselect';

import { ADDRESS_USE_CASE_TYPE } from '@core/reducers/cities/models/City';

import getSelectedCityAreas from './getSelectedCityAreas';
import getSelectedAreaId from './getSelectedAreaId';
import getSelectedCityDefaultArea from './getSelectedCityDefaultArea';
import getSelectedCityAddressUseCase from './getSelectedCityAddressUseCase';

const findArea = createSelector(
  getSelectedCityAreas,
  getSelectedAreaId,
  (areas, areaId) => areaId && areas.length && areas.find(a => a.id === areaId),
);

// SIMPLE_ADDRESS does not have area input, but for service is needed.
// So we select the city's default area.
function getDefaultArea(addressUseCase, defaultArea) {
  return addressUseCase === ADDRESS_USE_CASE_TYPE.SIMPLE_ADDRESS
    ? defaultArea
    : null;
}

const getSelectedArea = createSelector(
  findArea,
  getSelectedCityDefaultArea,
  getSelectedCityAddressUseCase,
  (foundArea, defaultArea, cityAddressUseCase) =>
    foundArea || getDefaultArea(cityAddressUseCase, defaultArea),
);

export default getSelectedArea;
